import React from 'react';
import * as Backend from "../backend.js";
import * as util from "../other/util.js";
import * as ICONS from "../other/icons.js";
import shared from '../share/shared.js';

// Shows information about the player and allows to update faction name and description
class PlayerProfileView extends util.GameComponent {
    constructor(props) {
        super(props);
        this.state = {};
    }

    refreshState() {
        let id = this.props.params.id;
        Backend.getPlayerAbstract(id, (res) => {
            this.setState({ player: res.player });
        });
    }

    render() {
        if (!this.hasCurrentState()) {
            return (<util.LoadingBar2 />);
        }

        let player = this.state.player;
        return (
            <div>
                <h1>
                    Player: {player.name}
                </h1>
                <PlayerDetails player={player} onUpdatePlayer={(player) => this.handlePlayerDetailsUpdate(player)} />
                <PlayerPlanetList player={player} onUpdatePlayer={(player) => this.handlePlayerDetailsUpdate(player)} />
                <h4>Research</h4>
                <p>
                    Points: {player.points - player.planets.reduce((acc, planet) => acc + planet.points, 0)}
                </p>
                <br />
                <util.JsonDebug obj={player} />
            </div>
        );
    }

    handlePlayerDetailsUpdate(player) {
        this.last_refresh_ts = Date.now();
        this.setState({ player: player });
    }
}

class PlayerDetails extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            editable: false,
            faction: this.props.player.faction,
            faction_description: this.props.player.faction_description,
            faction_description_error: undefined,
            faction_error: undefined,
            error: undefined,
        }
    }

    render() {
        let player = this.props.player;
        let editable = this.state.editable;


        let error_html;
        if (this.state.error) {
            error_html = (<tr>
                <td colSpan="2" style={{ color: "red" }}>{this.state.error}</td>
            </tr>);
        }

        let faction_error_html;
        if (this.state.faction_error) {
            faction_error_html = (<tr>
                <td colSpan="2" style={{ color: "red" }}>{this.state.faction_error}</td>
            </tr>);
        }

        let faction_description_error_html;
        if (this.state.faction_description_error) {
            faction_description_error_html = (<tr>
                <td colSpan="2" style={{ color: "red" }}>{this.state.faction_description_error}</td>
            </tr>);
        }

        return (
            <div>
                <div style={{ float: "right" }}>
                    {this.getButtons()}
                </div>
                <table style={{ width: "50%" }}>
                    <tbody>
                        <util.LabelValueInputTr label={"Name"} label_width={"20%"} value={player.name} colon={false} />
                        <util.LabelValueInputTr label={"Rank"} label_width={"20%"} value={player.rank} colon={false} />
                        <util.LabelValueInputTr label={"Points"} label_width={"20%"} value={player.points} colon={false} />
                        {error_html}
                        <util.LabelValueInputTr editable={editable}
                            label={"Faction"}
                            value={this.state.faction}
                            colon={false}
                            onChange={(value) => this._onChangeFaction(value)} />
                        {faction_error_html}
                        <util.LabelValueInputTr editable={editable}
                            label={"About"}
                            area={true}
                            value={this.state.faction_description}
                            colon={false}
                            onChange={(value) => this._onChangeFactionDescription(value)} />
                        {faction_description_error_html}
                    </tbody>
                </table>
            </div>
        );
    }

    // The button on the top right
    getButtons() {
        let player = this.props.player;
        let editable = this.state.editable;

        if (player.id !== util.getGPS().player_id) {
            return (<util.MessagePlayerLink playerId={player.id} playerName={player.name} />);
        } else {
            if (!editable) {
                return (<div className="action-button" onClick={() => this._activateEdit()}>edit</div>);
            } else {
                return (
                    <div>
                        <div className="action-button" onClick={() => this._cancelEdit()}>cancel</div>
                        <div className="action-button" onClick={() => this._saveEdit()}>save</div>
                    </div>);
            }
        }
    }

    _activateEdit() {
        this.setState({ editable: true });
    }

    _cancelEdit() {
        let player = this.props.player;
        this.setState({ editable: false, faction: player.faction, faction_description: player.faction_description, faction_error: undefined, faction_description_error: undefined });
    }

    _saveEdit() {
        Backend.tryPlayerDetailUpdate(this.state.faction, this.state.faction_description, (res) => {
            if (res.success) {
                this.setState({ editable: false, faction_error: undefined, faction_description_error: undefined });
                this.props.onUpdatePlayer(res.player);
            } else {
                this.setState({ faction_error: res.details?.faction, faction_description_error: res.details?.faction_description, error: res.error });
            }
        });
    }

    _onChangeFaction(faction) {
        this.setState({ faction: faction });
    }

    _onChangeFactionDescription(faction_description) {
        this.setState({ faction_description: faction_description });
    }
}

class PlayerPlanetList extends React.Component {
    constructor(props) {
        super(props);
        this.state = { planetNameError: null };
    }

    render() {
        let player = this.props.player;
        let planetNameError = this.state.planetNameError;

        return (
            <div>
                <h4>
                    Planets
                </h4>
                <div className="warning-text">
                    {planetNameError}
                </div>
                <table className="generic-list">
                    <tbody>
                        {player.planets.map((planet, idx) => <SinglePlanet key={idx} player={player} planet={planet} onUpdatePlayer={this.props.onUpdatePlayer} onSetPlanetNameError={(error) => this.handlePlanetNameError(error)} />)}
                    </tbody>
                </table>
            </div>
        );
    }

    handlePlanetNameError(error) {
        this.setState({ planetNameError: error });
    }
}

class SinglePlanet extends React.Component {
    constructor(props) {
        super(props);
        this.state = { editing: false, value: this.props.planet.name };
    }

    render() {
        const planet = this.props.planet;
        const player = this.props.player;
        return <tr>
            <td style={{ textAlign: "start" }}>
                {this.state.editing
                    ? <div>
                        <input value={this.state.value} onChange={event => this._handleValueChange(event.target.value)} style={{ marginRight: "6px" }} />
                        <span> </span>
                        <div className="action-button" onClick={() => this._handleOkClick()}>Ok</div>
                        <div className="action-button" onClick={() => this._handleCancelClick()}>Cancel</div>
                    </div>
                    : (<div>
                        {player.id === util.getGPS().player_id
                            ? <img src={ICONS.OTHER.edit} alt={"edit"} style={{ width: "22px", marginBottom: "-4px", marginRight: "12px", cursor: "pointer" }} onClick={() => this._handleEditClick()} />
                            : <div />}
                        <util.PlanetLink planet={planet} showSolarSystem={true} />
                    </div>)}
            </td>
            <td>
                {planet.points}
            </td>
        </tr>
    }

    _handleEditClick() {
        this.setState({ editing: true });
    }

    _handleValueChange(value) {
        this.setState({ value: value });
    }

    _handleOkClick() {
        const planet = this.props.planet;

        // Check name client-side first.
        try {
            shared.validatePlanetName(this.state.value);
        } catch (e) {
            this.props.onSetPlanetNameError(e.details.name);
            return;
        }

        // Send to backend.
        this.setState({ editing: false });
        Backend.changePlanetName(planet.x, planet.y, planet.z, this.state.value, (res) => {
            if (res.success) {
                this.props.onUpdatePlayer(res.player);
                this.props.onSetPlanetNameError(null);
            } else {
                this.props.onSetPlanetNameError(res.details.name);
            }
        });
    }

    _handleCancelClick() {
        this.setState({ editing: false });
        this.props.onSetPlanetNameError(null);
    }
}

export default util.withParams(PlayerProfileView);